export const PLACEHOLDERS = {
  PAYMENT_METHOD: 'Payment method(optional)',
  INSURANCE_NAME: 'Name of the insurer',
  MEMBERSHIP_NUMBER: 'Membership number',
  PRE_AUTH_CODE: 'Pre-Authorisation Code (optional)',
};

export const LABELS = {
  SELF_PAYING_QUESTION: 'Are you self paying?',
  YES: 'Yes',
  NO: 'No',
  PRIVATE_INSURANCE_DETAILS: 'Private insurance details',
  NEED_ALTERNATIVE_PAYMENT: 'Need an alternative payment method?',
  CONTACT_US_MESSAGE:
    "Contact us, and we'll be happy to arrange a solution for you. Call us on",
  PHONE_NUMBER: '0116 270 8033',
  INSURANCE_DISCLAIMER:
    'I understand that if my insurance company does not cover the full amount, I am responsible for paying any remaining balance.',
  DOES_NOT_COVER: 'does not cover the full amount',
  PRE_AUTH_CODE_MESSAGE:
    'We kindly request that you provide your pre-authorisation code to begin the verification process for your insurance details.',
};

export const TEST_IDS = {
  SELF_PAYING_YES: 'self-paying-yes',
  SELF_PAYING_NO: 'self-paying-no',
};

export const VALIDATION_MESSAGES = {
  PRE_AUTH_CODE_NUMBERS_ONLY:
    'Pre-Authorisation Code must contain only numbers',
  ACCEPT_RESPONSIBILITY: 'You must accept responsibility for remaining balance',
  SELECT_OPTION: 'Please select one of the options',
  INSURANCE_REQUIRED: 'Insurance is required',
  MEMBERSHIP_REQUIRED: 'Membership is required',
  MEMBERSHIP_INVALID: 'Membership is invalid',
};
